import vxCampaignConnect from '../../../components/campaigns/vx-campaign-connect/vx-campaign-connect.vue';
import vxCampaignVolunteerMatch from '../../../components/campaigns/vx-campaign-volunteer-match/vx-campaign-volunteer-match.vue';
import vxCampaignOurBelief from '../../../components/campaigns/vx-campaign-our-belief/vx-campaign-our-belief.vue';
import vxCampaignProgram from '../../../components/campaigns/vx-campaign-program/vx-campaign-program.vue';
import vxCampaignFixedMenu from '../../../components/campaigns/vx-campaign-fixed-menu/vx-campaign-fixed-menu.vue';
import vxCampaignGiants from '../../../components/campaigns/vx-campaign-giants/vx-campaign-giants.vue';
import vxCampaignBrawnyTakesAction from '../../../components/campaigns/vx-campaign-brawny-takes-action/vx-campaign-brawny-takes-action.vue';
import vxCampaignNominate from '../../../components/campaigns/vx-campaign-nominate/vx-campaign-nominate.vue';

export default {
  name: 'brawny-gta',
  components: {
    vxCampaignConnect,
    vxCampaignVolunteerMatch,
    vxCampaignOurBelief,
    vxCampaignProgram,
    vxCampaignFixedMenu,
    vxCampaignGiants,
    vxCampaignBrawnyTakesAction,
    vxCampaignNominate,
  },
  props: {
    campaignData: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    const mainEl = document.querySelector('#brawny .main__inner-wrapper');
    if (mainEl) {
      mainEl.setAttribute('style', 'max-width:100%');
      mainEl.parentElement.setAttribute('style', '-ms-overflow-x: hidden');
      const cFluid = mainEl.querySelector('.container-fluid');
      if (cFluid) {
        cFluid.setAttribute('style', 'background-color:#222');
      }

      const cFluidChild = cFluid.childNodes[0];
      if (cFluidChild) {
        cFluidChild.classList.remove('row');
      }
    }

    const nominateEl = document.querySelector('#nominate');
    if (nominateEl && window.location.hash) {
      if (window.location.hash === '#nominate') {
        jQuery('html, body').animate({
          scrollTop: nominateEl.offsetTop,
        }, 10);
      }
    }

    const gaintsEl = document.querySelector('#giants-section');
    if (gaintsEl && window.location.hash) {
      if (window.location.hash === '#giants-section') {
        jQuery('html, body').animate({
          scrollTop: gaintsEl.offsetTop + 12,
        }, 10);
      }
    }
  },
};




// WEBPACK FOOTER //
// ./src/brawny/components/brawny-gta/brawny-gta.js